import React from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

/**
 * Prévia ao vivo do modelo em edição, com valores de exemplo, num iframe isolado (srcDoc).
 * Com mais de um modo de exemplo (sample_modes), mostra o seletor para ver cada ramificação.
 * @param {{ preview: { loading: boolean, error: string|null, subject: string, preheader: string, html: string },
 *   modes?: Array<{ key: string, label: string }>, mode?: string, onModeChange?: Function }} props
 */
function TemplatePreviewPane({ preview, modes = [], mode = '', onModeChange }) {
  return (
    <Box sx={{ border: '1px solid #E2E8F0', borderRadius: '12px', overflow: 'hidden', backgroundColor: '#fff', display: 'flex', flexDirection: 'column', minHeight: 420 }}>
      <Box sx={{ px: 2, py: 1.25, borderBottom: '1px solid #EEF1F6', backgroundColor: '#FBFCFF' }}>
        <Typography variant="caption" color="text.secondary" component="div">Prévia com valores de exemplo</Typography>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>{preview.subject || 'Sem assunto'}</Typography>
        {preview.preheader && <Typography variant="caption" color="text.secondary" component="div">{preview.preheader}</Typography>}
        {modes.length > 1 && onModeChange && (
          <TextField
            select
            size="small"
            label="Situação de exemplo"
            value={mode || modes[0].key}
            onChange={(e) => onModeChange(e.target.value)}
            sx={{ mt: 1.25, minWidth: 240, backgroundColor: '#fff' }}
          >
            {modes.map((item) => <MenuItem key={item.key} value={item.key}>{item.label}</MenuItem>)}
          </TextField>
        )}
      </Box>
      <Box sx={{ height: 4 }}>{preview.loading && <LinearProgress />}</Box>
      {preview.error && <Alert severity="warning" sx={{ m: 2 }}>{preview.error}</Alert>}
      {preview.html && (
        <iframe
          title="Prévia do e-mail de acompanhamento"
          srcDoc={preview.html}
          sandbox="allow-popups allow-popups-to-escape-sandbox"
          style={{ width: '100%', flex: 1, minHeight: 520, border: 0, display: 'block', backgroundColor: '#FFFFFF', colorScheme: 'light' }}
        />
      )}
    </Box>
  );
}

export default TemplatePreviewPane;
